function getTransmissionDetails(state) {
	return state.inboundTransmission;
}
export default {  getTransmissionDetails };